export enum Message {
  AudioFrame = "AUDIO_FRAME",
  SpeechStart = "SPEECH_START",
  VADMisfire = "VAD_MISFIRE",
  SpeechEnd = "SPEECH_END",
  SpeechStop = "SPEECH_STOP",
  SpeechRealStart = "SPEECH_REAL_START",
  FrameProcessed = "FRAME_PROCESSED",
}
